export enum BadgeType {
  Primary = 'primary',
  Secondary = 'secondary'
}
